import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { CancelContractEnvelopeValidationSchema } from '@/features/privateCompanyLeadsFunnel/schemas/contractEnvelope.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCancelContractEnvelopeProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useCancelContractEnvelope = ({ id, onSuccess, onError }: UseCancelContractEnvelopeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['cancelContractEnvelope'],
    mutationFn: async (form: CancelContractEnvelopeValidationSchema) => {
      await privateAxios.put(`/funnel/private_company_leads/${id}/cancel_remote_signature`, {
        private_company_lead: {
          ...form,
        },
      })
    },
    onSuccess,
    onError,
  })
}
